import type { DocMigration } from "../docMigration";

// Copied from lib/house/plans/drawingTools.ts
const STATIC_MISSING_DRAWING_IMG_PATH = `/static/plans/details/detail_missing.png`;

// eslint-disable-next-line @typescript-eslint/naming-convention
const migration_0_0_146: DocMigration = {
  maxSchemaVersion: "0.0.146",
  description: "Ensure that url is properly set for all drawings",
  apply(json: any) {
    for (const id in json.settings) {
      const setting = json.settings[id];

      if (setting.type !== "DRAWING_CATALOG_SETTINGS") {
        continue;
      }

      for (const key in setting.drawings) {
        const drawing = setting.drawings[key];

        if (!drawing.url) {
          drawing.url = STATIC_MISSING_DRAWING_IMG_PATH;
        }
      }
    }

    return json;
  },
};

export default migration_0_0_146;
